import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import './styles/index.css';

import Home from './Pages/Home';
import About from './Pages/About';
import Donate from './Pages/Donate';
import DonateCurrency from './Pages/DonateCurrency';
import Reports from './Pages/Reports';
import ReportDetail from './Pages/ReportDetail';
import Contacts from './Pages/Contacts';
import BusinessSupport from './Pages/BusinessSupport';
import Programs from './Pages/Programs';
import Partners from './Pages/Partners';
import PartnerDetail from './Pages/PartnerDetail';
import GdprPolicy from './Pages/GdprPolicy';
import NotFound from './Pages/NotFound';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Something went wrong.</h2>
          <p>{this.state.error?.message}</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <ErrorBoundary>
          <Routes>
            {/* Legacy capitalized URL redirects — caseSensitive prevents them from
                matching lowercase routes like /about when /About is the target */}
            <Route caseSensitive path="/Home" element={<Navigate to="/" replace />} />
            <Route caseSensitive path="/About" element={<Navigate to="/about" replace />} />
            <Route caseSensitive path="/Contacts" element={<Navigate to="/contacts" replace />} />
            <Route caseSensitive path="/Reports" element={<Navigate to="/reports" replace />} />
            <Route caseSensitive path="/Donate" element={<Navigate to="/donate" replace />} />
            <Route caseSensitive path="/Partners" element={<Navigate to="/partners" replace />} />
            <Route caseSensitive path="/Business" element={<Navigate to="/business" replace />} />
            <Route caseSensitive path="/Programs" element={<Navigate to="/programs" replace />} />

            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/business" element={<BusinessSupport />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/partners/:id" element={<PartnerDetail />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/reports/:id" element={<ReportDetail />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/donate/currency" element={<DonateCurrency />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/gdpr-policy" element={<GdprPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ErrorBoundary>
      </Layout>
    </BrowserRouter>
  );
}

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hydrate pre-rendered HTML from react-snap; fall back to fresh render
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
